import { useEffect, useState } from 'react';

const HASH_REGEXP = /#([^?]+)/;

export const useHash = () => {
  const [hash, setHash] = useState<string | null>(null);

  useEffect(() => {
    const handlePopState = () => {
      setHash(window.location.href.match(HASH_REGEXP)?.[1] || null);
    };

    // Call handlePopState to initialize the hash value on component load
    handlePopState();

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return hash;
};
